import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient';

export const signOut = () => {
  const storage = new LocalStorageClient();
  storage.clear()
};
